import React from 'react';

export default function Section({ id, index, eyebrow, title, subtitle, children, altBg }) {
  return (
    <section
      id={id}
      className={`w-full ${altBg ? 'bg-[#F5F0E6]' : 'bg-[#FDFBF7]'}`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="flex items-baseline gap-3 mb-5">
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#B4A98C] font-medium">
            {index} —
          </span>
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#7A7466] font-medium">
            {eyebrow}
          </span>
        </div>

        {title && (
          <h2 className="font-serif text-[#2C2A26] text-[34px] md:text-[52px] leading-[1.05] tracking-tight max-w-4xl">
            {title}
          </h2>
        )}
        {subtitle && (
          <p className="mt-5 text-[#6b6558] text-base md:text-lg max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}

        <div className="mt-10 md:mt-14">{children}</div>
      </div>
    </section>
  );
}
